<template>
	<custom-bp-vuejs-dropdown  class="hamburger-menu-button" :initialIsHidden="isHidden">
		<template #btn>
			<button class="btn">
				<svg role="img" width="20px" height="20px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="#545454"
					class="bi bi-three-dots" aria-labelledby="showMoreIcon">
					
					<path
						d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
				</svg>
				<span class="panel-label">{{ content.more }}</span>
			</button>

		</template>
		<template #body>
			<div v-for="comp in listItems" :key="comp.name" class="comp-list-item" :class="{zoom: comp.name === 'zoom'}">
				<component :is="comp.component" />
			</div>

		</template>
		<template #icon><span></span></template>
	</custom-bp-vuejs-dropdown>
</template>

<script>
import BpVuejsDropdown from "@/components/bp-vuejs-dropdown/Dropdown.vue";
import featureMixin from "@/mixins/featureMixin";
import { controlDictV2 } from "@/features/FeatureHelper";
import {mapGetters} from "vuex";

export default {
	name: "HamburgerMenuButtonV2",
	mixins: [featureMixin],
	components: { CustomBpVuejsDropdown: {
		extends: BpVuejsDropdown,
		methods: {
			_onBodyLeave(e) {
				if (this.trigger !== 'hover') {
					return;
                }
                

                const to = e.toElement;
                if (!to) {
                    return;
                }

                if (to.closest('.bp-dropdown__btn') || to.closest('.bp-dropdown__sub')) {
                    return;
                }
				if (to.closest('div.tooltip-inner')) {
					return;
                }
				this.prepare();
            },
		}
	} },
	data() {
		return {
			isHidden: true,
			featurePath: 'header.controlsV2.hamburgerMenu-v2'
		}
	},
	computed: {
		...mapGetters('screen', ['displayMode']),
		listItems() {
			const items = this.config.items;
			const o = [];

			for (let item of items) {
				if (controlDictV2[item.component]) {
					o.push({ name: item.component, component: controlDictV2[item.component], desc: item.desc });
				}
			}

			return o;

		}
	},
}
</script>

<style lang="scss">
.hamburger-menu-button {
	.bp-dropdown__body {
		left: unset !important;
		right: 1em;
		padding: 0;
	}
}


[mode='tablet'],
[mode='mobile'] {
	.hamburger-menu-button {
		.bp-dropdown__body {
			left: 1em !important;
			width: calc(100% - 2em);
			display: flex;
			flex-direction: column;
		}
		
		.bp-dropdown__btn {
			padding: 0;
		}
	}
}

.hamburger-menu-button {
    padding: 0 !important;

	.hamburger-lines {
		fill: #545454
	}

	.bp-dropdown__body {
		top: 64px !important;
		border: 1px solid #AFAFAF;
	}

	.bp-dropdown__btn {
		padding: 5px 9px;
		border: none;
		flex-direction: column;
		background: none !important;

		.btn {
			border: none;
			border-radius: 0;
			display: flex;
			flex-direction: column;

			&:hover {
				background: none;
				color: var(--secondary-color);

				svg path {
					fill: var(--secondary-color);
				}
			}

			span {
				margin-top: 6px;
			}
		}

		&.bp-dropdown__btn--active {
			.hamburger-lines {
				fill: #E5E5E5;
			}

			.btn:hover {
				background-color: inherit;
			}
		}
	}

	.comp-list-item {
		display: flex;
		//column-gap: 1em;
		align-items: center;
		padding: 0.3em 0.5em;

		span {
			margin-left: 15px;
		}

		>* {
			margin-right: 0 0.2em;

		}

		&:hover {
			color: var(--secondary-color);

			svg path {
				fill: var(--secondary-color);
			}

			span {
				color: var(--secondary-color);
			}
		}
	}

	.comp-list-item:not(:last-child){
		border-bottom: 1px solid #AFAFAF;
	}


}

[mode=tablet],
[mode=mobile] {
	.hamburger-menu-button {
		.bp-dropdown__body {
			width: unset;
			left: unset !important;

			.comp-list-item.zoom {
				display: none;
			}
		}
		.hamburger-dropdown {
			top: 90px !important;
		}
	}
}</style>
